<script setup lang="ts">
definePageMeta({ prerender: true })

const { data: page } = await useAsyncData('eula', () => queryCollection('eula').first())

useSeoMeta({
  description: page.value?.description,
  title: page.value?.title,
})
</script>

<template>
  <UPageSection v-if="page">
    <div class="prose dark:prose-invert max-w-none">
      <ContentRenderer :value="page"/>
    </div>
  </UPageSection>
</template>
